export const WEBSITE_NAME = "DashBee";